import { ApolloClient } from '@apollo/client'
import { takeLatest } from 'redux-saga/effects'
import { actionTypes } from './index'
import createFetchSaga from '@utils/store/createFetchSaga'
import countriesGetQuery from '@queries/countriesGetQuery'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  return client
    .query({ query: countriesGetQuery, variables: action.payload })
    .then(({ data }) => ({ data: data?.countriesGet?.results }))
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return // dont run on SSR
  yield takeLatest(actionTypes.loadList.run, createFetchSaga(actionTypes.loadList.run, fetchList))
}
